import { Button, Flex } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../../_base/component/_layout/_breadcrumb";
import ConfigGroupProduct from "../EditView/ConfigGroupProduct";

const CreateViewConfigGroupV2 = () => {
  const navigate = useNavigate();

  const handleSaved = async () => {
    navigate("/product-manager/config-group-v2");
  };

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{ padding: "20px 10px" }}
      >
        <BreadCrumb />
        <Button
          leftSection={<IconArrowLeft size={18} />}
          onClick={() => navigate(-1)}
          variant="light"
        >
          Quay lại
        </Button>
      </Flex>
      <div style={{ position: "relative" }}>
        <ConfigGroupProduct
          initialName=""
          initialDescription=""
          dataConfigGroupProduct={[]}
          dataConfigGroupAttribute={[]}
          onSaved={handleSaved}
        />
      </div>
    </>
  );
};

export default CreateViewConfigGroupV2;
